import React, { useCallback, useEffect, useState } from 'react';
import { TreeDataState, CustomTreeData, SelectionState, DataTypeProvider, } from '@devexpress/dx-react-grid';
import { Grid, Table, TableHeaderRow, TableTreeColumn, } from '@devexpress/dx-react-grid-bootstrap4';
import { last } from '../../../../utils/array';
import { RowComponent, TableComponentBase } from '..';
import { RowPlugin } from '../../plugins';
import { useRowClickHandler } from '../../hooks';
import { CellFormatterFactory } from '../../formatters';
import { InfoHeaderContentFactory } from './components/InfoHeaderContentFactory';
import { WithGridDropdownCellComponent } from './components/WithGridDropdownCellComponent';
export const DataGridTree = ({ children, data, dataColumns, emitSelectedRowData, getChildRows, getRowId, idKey, rowHeader, autoExpandAllRows = false, autoExpandedChildRowsOnParentSelection = {
    autoSelectChildRows: false,
    autoClosePreviouslyExpandedGroup: true,
}, infoDOMAttributes, gridDropdownProps, tableColumnExtensions = [], }) => {
    const [rowSelection, setSelection] = useState([0]);
    const onRowSelection = (selectedRow) => {
        const rowUserSelected = last(selectedRow);
        if (autoExpandedChildRowsOnParentSelection && (autoExpandedChildRowsOnParentSelection === null || autoExpandedChildRowsOnParentSelection === void 0 ? void 0 : autoExpandedChildRowsOnParentSelection.autoSelectChildRows)) {
            const rowUserSelectedData = data.find((rowInData) => getRowId(rowInData) === rowUserSelected);
            const childRows = getChildRows(rowUserSelectedData, data);
            if (childRows) {
                setSelection([rowUserSelected].concat(childRows.map((childRow) => getRowId(childRow))));
            }
            else {
                setSelection([rowUserSelected]);
            }
        }
        else {
            setSelection([rowUserSelected]);
        }
    };
    const [expandedRowIds, setExpandedRowIds] = useState([]);
    const { handleRowClick } = useRowClickHandler();
    useEffect(() => {
        if (autoExpandAllRows && Array.isArray(data)) {
            setExpandedRowIds(data.map((row) => getRowId(row)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    const updateSelectedRowData = useCallback((rowData) => {
        if (emitSelectedRowData)
            emitSelectedRowData(rowData);
        if (autoExpandedChildRowsOnParentSelection && !autoExpandAllRows) {
            const childRows = getChildRows(rowData, data);
            if (childRows && childRows.length) {
                const parentAndChildRowIds = [getRowId(rowData)].concat(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                childRows.map((childRow) => getRowId(childRow)));
                const { autoClosePreviouslyExpandedGroup } = autoExpandedChildRowsOnParentSelection;
                if (autoClosePreviouslyExpandedGroup) {
                    setExpandedRowIds(parentAndChildRowIds);
                }
                else {
                    setExpandedRowIds(expandedRowIds.concat(parentAndChildRowIds));
                }
            }
        }
    }, [
        autoExpandedChildRowsOnParentSelection,
        autoExpandAllRows,
        data,
        emitSelectedRowData,
        expandedRowIds,
        getChildRows,
        getRowId,
    ]);
    const RowComponentWithProps = React.useCallback((props) => (React.createElement(RowComponent, Object.assign({}, props, { showSelection: true, setSelectedRowData: updateSelectedRowData, rowClickHandler: handleRowClick }))), [handleRowClick, updateSelectedRowData]);
    const CellFormatter = React.useCallback((props) => {
        if (children) {
            return React.createElement(DataTypeProvider, Object.assign({ formatterComponent: children }, props));
        }
        return React.createElement(CellFormatterFactory, Object.assign({}, props));
    }, [children]);
    // Order of children in Grid is important!
    return (React.createElement("div", { className: "base-data-grid" },
        React.createElement(Grid, { rows: data, columns: [rowHeader].concat(dataColumns), getRowId: getRowId },
            React.createElement(CellFormatter, { for: dataColumns.map(({ name }) => name) }),
            React.createElement(SelectionState, { selection: rowSelection, onSelectionChange: onRowSelection }),
            React.createElement(TreeDataState, { expandedRowIds: expandedRowIds, onExpandedRowIdsChange: setExpandedRowIds }),
            React.createElement(CustomTreeData, { getChildRows: getChildRows }),
            React.createElement(Table, { tableComponent: TableComponentBase, columnExtensions: tableColumnExtensions }),
            infoDOMAttributes ? (React.createElement(TableHeaderRow, { contentComponent: InfoHeaderContentFactory({ infoDOMAttributes }) })) : (React.createElement(TableHeaderRow, null)),
            React.createElement(TableTreeColumn, { for: idKey, cellComponent: WithGridDropdownCellComponent(gridDropdownProps) }),
            React.createElement(RowPlugin, { RowComponent: RowComponentWithProps }))));
};
//# sourceMappingURL=DataGridTree.js.map